import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ImageOverlay } from 'pages/onboarding/ImageOverlay';
import { useRedirect } from '../../../../../utils/redirect';
import { RIBOnboardingRoutes } from '../../routes/index';
import { ModalCard } from '../../../../../components/cards/ModalCard';
import { OnboardingGrid } from '../../../OnboardingGrid';
import { Grid } from '../../../../../components/layout/Grid';
import ordinaryHouseButSaferImage from '../../../../../assets/media/rib/ordinary-house-but-safer.jpg';
import { Brikk } from '../../../../../components/Brikk';
import { Text } from '../../../../../components/typography';
import { NextStep } from '../../../../../components/form-elements/buttons/NextStep';

export const OrdinaryHouseButSafer = () => {
  const { onRedirect } = useRedirect(RIBOnboardingRoutes.YOUR_INFO);

  return (
    <ModalCard>
      <OnboardingGrid>
        <Grid.Column>
          <ImageOverlay
            imageSrc={ordinaryHouseButSaferImage}
            overlayIntl="onboardingOrdinaryHouseButSaferTitle"
          />
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="onboardingOrdinaryHouseButSaferHeading">
            <Text size={18}>
              <FormattedMessage id="onboardingOrdinaryHouseButSaferDescription" />
            </Text>
          </Brikk.Heading>
        </Grid.Column>

        <NextStep onClick={() => onRedirect()} />
      </OnboardingGrid>
    </ModalCard>
  );
};
